// extracted by mini-css-extract-plugin
export default {"custom":"CustomScene_custom__wZ2og","custom_p":"CustomScene_custom_p__8h9+r"};